import * as joke from './joke';

export default {
  joke,
};
